export default class Panels {
  public readonly panels = [];

  public constructor(questions) {
    let panel;
    questions.forEach((question) => {
      if (question.title || question.type === 'complete' || question.type === 'unsure' || question.type === 'unsure1A3') {
        panel = [];
        this.panels.push(panel);
      }
      panel.push(question);
    });
  }
}
